import React from "react";
import styled from "styled-components";
import {
  faFacebook,
  faInstagram,
  faBluesky,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FooterContainer = styled.footer`
  height: 4rem;
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  justify-content: space-evenly;
  border-top: 1px solid lightgray;
  > * {
    flex-grow: 1;
    border-right: 1px solid black;
    color: white;
    display: flex;
    transition: 0.3s;
    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      // color: white;
      color: white;
    }
  }
`;

const FooterIcon = styled(FontAwesomeIcon)`
  margin: auto;
  font-size: 1.5rem;
`;

export default function Footer({ size }) {
  return (
    <FooterContainer>
      <a
        target="_blank"
        href="https://www.facebook.com/TheLubberFiend"
        rel="noreferrer"
        aria-label="Facebook Link"
      >
        <FooterIcon icon={faFacebook}></FooterIcon>
      </a>
      <a
        target="_blank"
        href="https://bsky.app/profile/thelubberfiend.bsky.social"
        rel="noreferrer"
        aria-label="Bluesky Link"
      >
        <FooterIcon icon={faBluesky}></FooterIcon>
      </a>
      <a
        target="_blank"
        href="https://www.instagram.com/thelubberfiend/"
        rel="noreferrer"
        aria-label="Instagram Link"
      >
        <FooterIcon icon={faInstagram}></FooterIcon>
      </a>
      <a
        target="_blank"
        href="https://www.lubberfiend.shop/"
        rel="noreferrer"
        aria-label="Shop Link"
      >
        <FooterIcon icon={faShoppingCart}></FooterIcon>
      </a>
      {/* {size.height > 900 ? ( */}
      <a
        target="_blank"
        href="mailto:info@thelubberfiend.com"
        rel="noreferrer"
        aria-label="Email Link"
      >
        <FooterIcon icon={faEnvelope}></FooterIcon>
      </a>
      {/* ) : (
        <NameContainer>
          <Name>THE LUBBER FIEND</Name>
        </NameContainer>
      )} */}
    </FooterContainer>
  );
}
